import script from "./InvoiceSection10.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSection10.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSection10.vue?vue&type=style&index=0&id=2efaaf97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2efaaf97"]])

export default __exports__